"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _map2 = _interopRequireDefault(require("lodash/map"));

var _themeUi = require("theme-ui");

var _core = require("@emotion/core");

var _utilities = require("../Modules/Layer/utilities");

var _base = require("../theme/lce/base");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var SliceProvider = function SliceProvider(_a) {
  var _b = _a.theme,
      customTheme = _b === void 0 ? {} : _b,
      global = _a.global,
      children = _a.children;
  var theme = (0, _themeUi.merge)(_base.lceBase, customTheme);
  (0, _react.useLayoutEffect)(function () {
    (0, _utilities.createLayerPortalNode)();
  }, []);
  return _react.default.createElement(_themeUi.ThemeProvider, {
    theme: theme
  }, global && (0, _map2.default)(global, function (styles, i) {
    return _react.default.createElement(_core.Global, {
      key: "global-styles-" + i,
      styles: styles
    });
  }), children);
};

var _default = SliceProvider;
exports.default = _default;